import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "title", "id", "tooltipPlacement", "aria-label"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { forwardRef } from 'react';
import { mergeCallbacks } from 'utils/ui';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import useUniqueId from 'hooks/useUniqueId';
var TooltipButton = /*#__PURE__*/forwardRef(function (_ref, outerRef) {
  var as = _ref.as,
    children = _ref.children,
    title = _ref.title,
    id = _ref.id,
    tooltipPlacement = _ref.tooltipPlacement,
    ariaLabel = _ref['aria-label'],
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'button';
  var tooltipId = useUniqueId(id ? "".concat(id.toString(), "-tooltip") : undefined);

  // Destructuring `iconOnly` and separately passing it into the
  // <Button> component below makes TS go crazy, so we reassign it like this:
  var isIconOnlyButton = otherProps.iconOnly;
  var useTitleAsDescription = !isIconOnlyButton && (Boolean(children) || Boolean(ariaLabel));
  var descriptionId = useTitleAsDescription ? tooltipId : undefined;

  /*
   Warning!!! `Button` is currently not being properly typechecked.
   Comment out `otherProps` and `as` when making changes to check types 
  */
  if (!title && !isIconOnlyButton) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
      as: Component,
      ref: outerRef,
      id: id,
      "aria-label": ariaLabel
    }), children);
  }

  /*
   Warning!!! `Button` is currently not being properly typechecked.
   Comment out `otherProps` and `as` when making changes to check types 
  */
  return /*#__PURE__*/React.createElement(Tooltip, {
    delay: 250,
    content: isIconOnlyButton && !title ? children : title,
    placement: tooltipPlacement,
    renderWhenClosed: Boolean(useTitleAsDescription),
    id: descriptionId,
    referenceRef: outerRef
  }, function (_ref2) {
    var ref = _ref2.ref,
      open = _ref2.open,
      close = _ref2.close;
    return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
      as: Component,
      id: id,
      ref: ref,
      onMouseEnter: mergeCallbacks(open, otherProps.onMouseEnter),
      onMouseLeave: mergeCallbacks(close, otherProps.onMouseLeave),
      onMouseDown: mergeCallbacks(close, otherProps.onMouseDown),
      onTouchStart: mergeCallbacks(open, otherProps.onTouchStart),
      onTouchEnd: mergeCallbacks(close, otherProps.onTouchEnd),
      onFocus: mergeCallbacks(open, otherProps.onFocus),
      onBlur: mergeCallbacks(close, otherProps.onBlur),
      "aria-label": useTitleAsDescription ? ariaLabel : title,
      "aria-describedby": descriptionId
    }), children);
  });
});
TooltipButton.displayName = 'TooltipButton';
export default TooltipButton;